import loadable from "@loadable/component";
import {
  loadableAuthParams,
  loadableRootParams,
} from "@components/Skeleton/loadableParams";

const Counsellor = {
  UsersAccountSelection: loadable(
    () => import("@components/UsersAccountSelection/UsersAccountSelection"),
    loadableRootParams,
  ),
  Users: loadable(
    () => import("@pages/Principal/Users/UsersTable"),
    loadableRootParams,
  ),
  ChangeUser: loadable(
    () => import("@pages/Principal/Users/ChangeUser"),
    loadableRootParams,
  ),
  ProfileUser: loadable(
    () => import("@pages/Principal/Users/ProfileUser"),
    loadableRootParams,
  ),
  Appointments: loadable(() => import("./Appointments"), loadableRootParams),
  AppointmentDetail: loadable(
    () => import("./AppointmentDetail"),
    loadableRootParams,
  ),
  Messages: loadable(() => import("./Messages"), loadableRootParams),
  Students: loadable(() => import("./Students"), loadableRootParams),
  Reports: loadable(() => import("./Reports"), loadableRootParams),
  StudentNotesList: loadable(
    () => import("./Notes/NotesList/NotesList"),
    loadableRootParams,
  ),
  StudentStatistics: loadable(
    () => import("./Statistics/Statistics"),
    loadableRootParams,
  ),
  StudentNotesAdd: loadable(
    () => import("./Notes/NoteAdd/NoteAdd"),
    loadableRootParams,
  ),
  StudentNotesItem: loadable(
    () => import("./Notes/NoteItem/NoteOverview"),
    loadableRootParams,
  ),
  Booking: loadable(() => import("./AppointmentBooking"), loadableRootParams),
  FreeTime: loadable(() => import("./FreeTime"), loadableRootParams),
  Config: loadable(
    () => import("@components/SurveyAndCheckIns"),
    loadableRootParams,
  ),
  ConfigCreate: loadable(
    () => import("@components/SurveyAndCheckIns/Create/CreateConfig"),
    loadableRootParams,
  ),
  CreateOwnTempLate: loadable(
    () => import("@components/SurveyAndCheckIns/Create/CreateOwnTemplate"),
    loadableRootParams,
  ),
  ProcessCreate: loadable(
    () => import("./Process/ProcessCreate/ProcessCreate"),
    loadableRootParams,
  ),

  Statistic: loadable(
    () => import("@components/Statistics/Statistics"),
    loadableRootParams,
  ),
  StudentReportItem: loadable(
    () => import("./Reports/Notes/NoteItem/ReportOverview"),
    loadableRootParams,
  ),

  StudentCustomReportItem: loadable(
    () => import("./Reports/Notes/NoteItem/CustomReportOverview"),
    loadableRootParams,
  ),
  CustomReports: loadable(
    () => import("@components/CustomReports/CustomReports"),
    loadableRootParams,
  ),
  CreateReportConfig: loadable(
    () => import("@components/CustomReports/Create/CreateReportConfig"),
    loadableRootParams,
  ),
  CreateReportTempLate: loadable(
    () => import("@components/CustomReports/CreateTemplate"),
    loadableRootParams,
  ),
  CreateReportConfigEdit: loadable(
    () => import("@components/CustomReports/Create/CreateReportConfig"),
    loadableRootParams,
  ),
  Questions: loadable(
    () => import("../Student/Questions/Question"),
    loadableRootParams,
  ),
  ProcessList: loadable(
    () => import("./Process/ProcessList/ProcessList"),
    loadableRootParams,
  ),
  ProcessStudentDetail: loadable(
    () => import("./Process/ProcessStudentDetail/ProcessStudentDetail"),
    loadableRootParams,
  ),
  ProcessEvents: loadable(
    () => import("./Process/ProcessEvents/ProcessEvents"),
    loadableRootParams,
  ),
  ProcessInformation: loadable(
    () => import("./Process/ProcessInformation/ProcessInformation"),
    loadableRootParams,
  ),
  ProcessBulkView: loadable(
    () => import("./Process/ProcessBulkView/ProcessBulkView"),
    loadableRootParams,
  ),
  ReferralList: loadable(
    () => import("./Referrals/ReferralList/ReferralList"),
    loadableRootParams,
  ),
  ReferralDetail: loadable(
    () => import("./Referrals/ReferralDetail/ReferralDetail"),
    loadableRootParams,
  ),
  ConsentList: loadable(
    () => import("./Consents/ConsentList/ConsentList"),
    loadableRootParams,
  ),
  ConsentDetail: loadable(
    () => import("./Consents/ConsentDetail/ConsentDetail"),
    loadableRootParams,
  ),
};

export default Counsellor;
